/** Tab values handled by DashboardHeader / TabContent */
export const DASHBOARD_TAB_VALUES = [
  'milkyway',
  'moon',
  'trips',
  'profile',
  'subscription',
] as const;

export type DashboardTab = (typeof DASHBOARD_TAB_VALUES)[number];

export const DEFAULT_DASHBOARD_TAB: DashboardTab = 'milkyway';

export function resolveDashboardTab(tab: string | null | undefined): DashboardTab {
  if (tab && (DASHBOARD_TAB_VALUES as readonly string[]).includes(tab)) {
    return tab as DashboardTab;
  }
  return DEFAULT_DASHBOARD_TAB;
}

/**
 * Accept only same-origin dashboard paths (pathname must start with /dashboard).
 * Rejects absolute URLs, protocol-relative paths, and non-dashboard paths.
 */
export function sanitizeDashboardReturnPath(
  candidate: string | null | undefined
): string | null {
  if (!candidate || typeof candidate !== 'string') {
    return null;
  }

  const trimmed = candidate.trim();
  if (!trimmed.startsWith('/')) {
    return null;
  }

  // Reject protocol-relative and backslash tricks
  if (trimmed.startsWith('//') || trimmed.includes('\\')) {
    return null;
  }

  // Reject embedded schemes (e.g. /dashboard?next=https://evil.com)
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed)) {
    return null;
  }

  let pathname: string;
  let search = '';

  try {
    const url = new URL(trimmed, 'https://www.milkywayplanner.com');
    pathname = url.pathname;
    search = url.search;
  } catch {
    return null;
  }

  if (!pathname.startsWith('/dashboard')) {
    return null;
  }

  return `${pathname}${search}`;
}

export function buildDashboardReturnNext(pathname: string, search: string): string {
  return encodeURIComponent(`${pathname}${search}`);
}
